module.exports = __webpack_public_path__ + "static/media/booksellicon.550ff680.png";